import { STALE_TIME, GC_TIME, QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const buildingConfig = {
  createBuilding: {
    key: "createBuilding",
    url: "/api/v1/buildings",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getBuildings"],
      onSuccessMessage: "Building created successfully",
      onErrorMessage: "Failed to create building",
    },
  },

  getBuildings: {
    key: "getBuildings",
    url: "/api/v1/buildings",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },


  getBuildingById: {
    key: "getBuildingById",
    url: (data) => `/api/v1/buildings/${data.id}`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.DETAIL,
    },
  },

  updateBuilding: {
    key: "updateBuilding",
    url: (data) => `/api/v1/buildings/${data.id}`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getBuildings", "getBuildingById"],
      onSuccessMessage: "Building updated successfully",
      onErrorMessage: "Failed to update building",
    },
  },

  getDeletedBuildings: {
    key: "getDeletedBuildings",
    url: "/api/v1/buildings/deleted",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  deleteBuilding: {
    key: "deleteBuilding",
    url: (data) => `/api/v1/buildings/${data.id}`,
    method: "DELETE",
    options: {
      retry: 2,
      invalidateKeys: ["getBuildings", "getDeletedBuildings"],
      onSuccessMessage: "Building deleted successfully",
      onErrorMessage: "Failed to delete building",
    },
  },

  restoreBuilding: {
    key: "restoreBuilding",
    url: (data) => `/api/v1/buildings/${data.id}/restore`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getBuildings", "getDeletedBuildings"],
      onSuccessMessage: "Building restored successfully",
      onErrorMessage: "Failed to restore building",
    },
  },

  // Floor management
  addFloor: {
    key: "addFloor",
    url: (data) => `/api/v1/buildings/${data.buildingId}/floors`,
    method: "POST",
    options: {
      invalidateKeys: ["getBuildings", "getBuildingById"],
      onSuccessMessage: "Floor added successfully",
      onErrorMessage: "Failed to add floor",
    },
  },

  updateFloor: {
    key: "updateFloor",
    url: (data) => `/api/v1/buildings/${data.buildingId}/floors/${data.floorId}`,
    method: "PATCH",
    options: {
      invalidateKeys: ["getBuildings", "getBuildingById"],
      onSuccessMessage: "Floor updated successfully",
      onErrorMessage: "Failed to update floor",
    },
  },

  deleteFloor: {
    key: "deleteFloor",
    url: (data) => `/api/v1/buildings/${data.buildingId}/floors/${data.floorId}`,
    method: "DELETE",
    options: {
      invalidateKeys: ["getBuildings", "getBuildingById"],
      onSuccessMessage: "Floor removed successfully",
      onErrorMessage: "Failed to remove floor",
    },
  },

  restoreFloor: {
    key: "restoreFloor",
    url: (data) => `/api/v1/buildings/${data.buildingId}/floors/${data.floorId}/restore`,
    method: "PATCH",
    options: {
      invalidateKeys: ["getBuildings", "getBuildingById", "getRooms"],
      onSuccessMessage: "Floor restored successfully",
      onErrorMessage: "Failed to restore floor",
    },
  },
};
